import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { colors, fonts, frames, useMediaQuery } from "../../../../Styles";
import { PageHeader, IoTable, LfSettings, Overlay, NewModal, MainContentPaddingTypes, NewButton } from "../../../../Components";
import { useAppSelector } from "../../../../Store";
import { Graph_QL, useSystem, useDeviceInfo } from "../../../../Services";
import { Pages } from "../../../../Navigation/root";
import ConfirmModal from "../../../../Components/_Components/confirmModal";

const SYSTEM_ID = 1;

export default function FreedaLocationFeeder() {
  const { t } = useTranslation();
  const [editLfSettings, setEditLfSettings] = useState(false);
  const [editIOTable, setEditIOTable] = useState(false);
  const [modalState, setModalState] = useState<"delete" | undefined>(undefined);
  const [message, setMessage] = useState<string | undefined>(undefined)

  const { systemId: urlSystemId } = useParams(); // TODO routing changes in order to get a correct system info
  const systemId = urlSystemId ? +urlSystemId : SYSTEM_ID;

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getSystemCall, data: systemsState } = useSystem(connection);

  useEffect(() => {
    getSystemCall({ ids: [systemId] });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);

  // Get System Name for Header
  const system = useMemo(() => {
    return systemsState[domain]?.data.find(
      (system) => system.system_id === systemId
    );
  }, [domain, systemId, systemsState]);
  
  const { data: deviceInfoState, call: getDeviceInfo, maintainEntries: maintainDeviceInfo } = useDeviceInfo(connection);

  const deviceInfo = useMemo(() => {
    if (deviceInfoState[domain]) {
      return deviceInfoState[domain].data.filter((device) => device?.system_assignment === systemId );
    }
    return [];
  }, [deviceInfoState, domain, systemId]);

  useEffect(() => {
    getDeviceInfo({ fetchAmount: 500 }, connection);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);
  // #endregion

  const seperator = <div style={{ width: "95%", height: "2px", borderTop: "2px solid "+colors.greyDarkPrimary }} />

  return ( <React.Fragment>
    <frames.Page_inner>
      {editLfSettings ||editIOTable ? <Overlay overrides={{ }} beforeUnload onClickAlert /> : <></>}
      <PageHeader
        topHeader={system?.name}
        subHeader={t(`menuHeaders.${Pages.freeda_lf_settings}`, { defaultValue: "settings" })}
        // optionButtons={{ contents: [t("locationFeederPages.settings.deleteSystem", { defaultValue: "delete system" })], onClick: () => { setModalState("delete") } }} // TODO delete system
      />
      <frames._page_inner_content_scroll>
        <div style={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column"}} >
          <LfSettings onDirtyChange={setEditLfSettings} zIndex={editLfSettings ? 9999 : undefined}/>
          {seperator}
          <IoTable onEditTable={setEditIOTable} zIndex={editIOTable ? 9999 : undefined} deviceInfo={deviceInfo} maxTableHeight="400px" showSystemRow={false} maintainDeviceInfo={maintainDeviceInfo} />
        </div>
      </frames._page_inner_content_scroll>
    </frames.Page_inner>

    {modalState === "delete" && 
      <ConfirmModal
        onCancel={() => setModalState(undefined)}
        disclaimer={`${t("locationFeederPages.settings.deleteDisclaimer", { defaultValue: "Are you sure you want to delete this system?" })}?`}
        onConfirm={() => console.log("delete confirmed") } // TODO delete action and close modal
        message={message} // TODO fallback message
      />
    }
  </React.Fragment> );
}
